<template src="../templates/grid-view.html" />

<script setup>

import { defineProps, computed, toRefs } from 'vue';
import { FavouriteIcon } from '@timezoneone/favourites';
import { showPublishDate, showCategory } from '../config/config.js';

const props = defineProps({
    results: {
        type: Array,
        required: true,
    },
    isLoading: {
        type: Boolean,
        required: true,
    },
    categoriesFacets: {
        type: Array,
        required: true,
    },
});
const { results } = toRefs(props);

const favButtonCssClasses = ['button', 'favourites'];

const scrollToBlogWrapper = () => {

    const element = document.getElementById('blog-app');

    if (element) {

        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: elementPosition, behavior: 'smooth' });

    }

};

</script>
